import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setExposureState } from '../store/exposure.actions'

export function* getExposureState(pcrDoc: IPcr) {
  const { exposure } = pcrDoc
  if (exposure && Object.keys(exposure).length !== 0) {
    yield put(setExposureState(exposure))
  }
}
